import { render } from "./ThemeButton.vue?vue&type=template&id=6368c3ac&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=6368c3ac&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6368c3ac"]])

export default __exports__